import React from "react";
import { appData } from "../../landing/data";
import paymentImg from "../../assets/images/home-eight/payment-img.png";

export default function Features() {
  return (
    <section id="features" className="py-[70px] md:py-[130px]">
      <div className="mx-auto theme-container">
        <h1 className="px-5 bg-blue-sass/10 border border-blue-sass/20 text-blue-sass font-medium rounded-[30px] w-fit mx-auto">
          Features
        </h1>
        <h2 className="sm:text-48 text-24 md:my-10 font-semibold text-main-black mb-[32px] mt-[18px] w-full max-w-[795px] text-center mx-auto">
          {appData.features.title}
        </h2>
        <div className="grid w-full max-w-[1070px] mx-auto grid-cols-6 lg:grid-cols-10">
          <div className="col-span-6 lg:col-span-4 lg:pr-[72px] flex flex-col justify-center gap-4">
            {appData.features.options.map((option, index) => (
              <div key={index} className="bg-blue-sass/5 py-[13px] px-8 border-l-[3px] border-blue-sass h-[50px] hover:h-max transition-all duration-300 overflow-hidden">
                <h1 className="font-semibold text-18 text-main-black whitespace-nowrap">
                  {option.feature}
                </h1>
                <p className="text-paragraph mt-0.5">
                  {option.description}
                </p>
              </div>
            ))}
          </div>
          <div className="col-span-6 mt-5 lg:mt-0 p-3 bg-gray-400 h-max rounded-xl">
            <img
              src={paymentImg}
              alt=""
              className="object-cover rounded-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
